import { Menu, HStack, Avatar, Portal, Box, VStack, Text } from "@chakra-ui/react";
import { PersonIcon } from "@digital-services-gard-as/anchor-icons";
import { useTranslation } from "react-i18next";

export const UserMenu = ({
    profileName,
    email,
    onSignout
}: {
    profileName?: string;
    email?: string;
    onSignout: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <Menu.Root>
            <Menu.Trigger asChild>
                <HStack gap="3" cursor="pointer" role="button" tabIndex={0} aria-label={t("userMenuButtonAriaLabel")}>
                    <Avatar.Root color="anchor.navy.900" backgroundColor="anchor.navy.100">
                        <Avatar.Fallback name={profileName}>{!profileName && <PersonIcon />}</Avatar.Fallback>
                    </Avatar.Root>
                </HStack>
            </Menu.Trigger>

            <Portal>
                <Menu.Positioner>
                    <Menu.Content minW="220px" maxW="300px">
                        <Box px="3" py="2">
                            <HStack gap="3">
                                <Avatar.Root size="sm" color="anchor.navy.900" backgroundColor="anchor.navy.100">
                                    <Avatar.Fallback name={profileName} />
                                </Avatar.Root>

                                <VStack align="start" gap="0">
                                    <Text fontWeight="medium" fontSize="sm">
                                        {profileName}
                                    </Text>
                                    {email && (
                                        <Text fontSize="xs" color="gray.500">
                                            {email}
                                        </Text>
                                    )}
                                </VStack>
                            </HStack>
                        </Box>

                        <Menu.Separator />
                        <Menu.Item id="signoutBtn" value="logout" onClick={onSignout}>
                            {t("logout")}
                        </Menu.Item>
                    </Menu.Content>
                </Menu.Positioner>
            </Portal>
        </Menu.Root>
    );
};
